import { FC, useEffect } from "react"
import useConfig from "src/hooks/useConfig"
import uttaLogo from "src/assets/media/utta_icon.png"
import livesellLogo from "src/assets/media/livesell_icon.png"
import x121Logo from "src/assets/media/x121_icon.png"
import learnmachineLogo from "src/assets/media/learnmachine_icon.png"
import { setPageAttributes } from "src/util"

export const ConditionalMeta: FC = () => {
  const { platformName } = useConfig()

  switch (platformName) {
    case "LearnMachine":
      return (
        <Meta
          title="LearnMachine | Personal Avatar Learning"
          description="LearnMachine"
          author="LearnMachine"
          favicon={learnmachineLogo}
        />
      )
    case "LiveSell":
      return (
        <Meta
          title="LiveSell | Livestream Shopping & Shoppable Video Platform"
          description="LiveSell brings livestream video and shoppable video to digital storefronts to drive engagement and grow sales."
          author="LiveSell"
          favicon={livesellLogo}
        />
      )
    case "Utta":
      return (
        <Meta
          title="Utta | Personal Avatar Chat"
          description="Utta"
          author="Utta"
          favicon={uttaLogo}
        />
      )
    case "x121":
      return (
        <Meta
          title="x121 | Virtual Chat"
          description="x121"
          author="x121"
          favicon={x121Logo}
        />
      )
    default:
    case "loading":
      return <Meta title="Loading" />
  }
}

type MetaProps = {
  title: string
  description?: string
  author?: string
  favicon?: string
}
const Meta: FC<MetaProps> = ({ title, description, author, favicon }) => {
  useEffect(() => {
    setPageAttributes(null, favicon)
  }, [favicon])

  return (
    <>
      <title>{title}</title>
      <meta content={title} name="title" property="og:title" />
      {description && (
        <meta
          content={description}
          name="description"
          property="og:description"
        />
      )}
      {author && <meta content={author} name="author" />}
    </>
  )
}
